"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@main/constants");
var tsdom_1 = __importDefault(require("tsdom"));
var focus_1 = require("./focus");
var Modal = function (modalId) { return ({
    open: function () {
        var mdl = tsdom_1.default(modalId);
        if (mdl.html()) {
            mdl.css({ display: 'block' });
            tsdom_1.default('body').addClass('hidden');
            focus_1.focus(modalId);
            mdl.find('.modal-close').on(constants_1.CLICK, function () {
                Modal(modalId).close();
            });
            window.onclick = Modal(modalId).remove;
        }
    },
    remove: function (e) {
        var mdl = tsdom_1.default(modalId);
        var current = mdl[0];
        if (current && current === e.target) {
            mdl.css({ display: 'none' });
            tsdom_1.default('body').removeClass('hidden');
        }
    },
    close: function () {
        var mdl = tsdom_1.default(modalId);
        if (mdl.html()) {
            mdl.css({ display: 'none' });
            tsdom_1.default('body').removeClass('hidden');
        }
    },
}); };
exports.default = Modal;
